<div class="container-fluid">
  <div class="row">
    <div class="col welcome">
      <h1>Looking for your next reading?</h1>
      <br>
      <form class="d-flex">
        <input #keywordBox class="form-control search" type="search"
          (keydown.enter)="searchKey(keywordBox.value); onKeyDownEvent($event)" placeholder="Search a book"
          (input)="searchKey(keywordBox.value)">
        <button class="btn" type="button"><a routerLink="/search"><img src="../assets/img/search.png" title="Search!"/></a></button>
        <!--<a href="https://www.flaticon.com/authors/smashicons" target="_blank">Designed by Smashicons / flaticon</a>-->
      </form>
      <br><br>
      <p>BookWorm SE is a book search engine that helps you find information about any book by title, author or genre. You can refine your search with filters and more info you know about the volume you are looking for. And check out how long it will take to read your next book as well!</p>
      <p>For further information, check our <a href="https://github.com/chachir/open-libra/" target="_blank">GitHub repo</a>.</p>
      <br><br>
      <a href="http://www.freepik.com" target="_blank"><img src="../assets/img/wormabc.png" title="Designed by pch.vector / freepik" width="30%" height="30%"></a>
    </div>
    <div class="col">
      <app-book-carousel></app-book-carousel>
    </div>
  </div>
</div>
